import { Box, Grid } from "@mui/material";
import {
  clearAllCardSelection,
  clearOpenSections,
  setActiveActionCard,
  setInnCode,
  setOpenSections
} from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import Feedback from "components/common/Feedback";
import { filterPage } from "components/common/Filters/FiltersHelper";
import PlanType from "components/common/PlanType";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { tokens } from "styles/Tokens";
import { messages } from "utils/CommonConstants";
import { formFilterRequestPayload, getHltInncodes } from "utils/CommonFunctions";
import { responseTypes } from "utils/Types";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import Basictabs from "../../common/Tabs";
import { updateRecentlyViewedData } from "../Corp/CorpUser.Slice";
import { clearPlanDetail, fetchPlanDetailAsync, setCopySectionData, setIsShareable } from "./PlanDetail.slice";
import PlanDetailsContent from "./PlanDetailsContent";
import { libraryPlanTabs } from "./TabsConfig";

export default function PlanDetails() {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { isAbovePropertyUser, isCorp } = useAppSelector((state) => state.app.loggedInUserDetails);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const selectedPlanDetail: any = useAppSelector((state) => state.planDetails.planDetails);
  const innCodes = getHltInncodes();
  const [searchParams] = useSearchParams();
  const isShareable = searchParams.get("isshareable") as string;
  const { id: planId, secId } = useParams();
  const [multipleInncodeFeedback, setmultipleInncodeFeedback] = useState<any>();
  const [multipleInncodePlan, setmultipleInncodePlan] = useState(false);
  const { isMobileScreen } = useContext(ThemeContext);
  const isShareablePlan: any = useAppSelector((state) => state?.planDetails?.isShareablePlan);
  const pageName = filterPage.libraryPlanDetailsDisplay;
  const globalFiltersforPage = useAppSelector((state) => state.globalFilters[pageName]);
  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];

  useEffect(() => {
    if (!isAbovePropertyUser) {
      dispatch(
        updateRecentlyViewedData({
          cmsPlan: [
            {
              cmsId: planId,
              ...(isCorp ? {} : { innCode })
            }
          ]
        })
      );
    }

    return () => {
      dispatch(clearPlanDetail());
      dispatch(clearAllCardSelection());
      dispatch(setActiveActionCard({}));
      dispatch(setCopySectionData({}));
      dispatch(setIsShareable(false));
    };
  }, []);

  useEffect(() => {
    if (isShareable) return;
    dispatch(clearOpenSections());
    getPlandetails({
      planId,
      innCode: location?.state?.innCode || innCode,
      fetchAllImplementedPlans: location?.state?.fetchAllImplementedPlans || false,
      shouldRetainData: filterRequestPayload?.length ? true : false,
      ...formFilterRequestPayload(filterRequestPayload)
    });
  }, [dispatch, planId, innCode, filterRequestPayload]);

  const getPlandetails = async (data: any) => {
    const res = await dispatch(fetchPlanDetailAsync(data));
    if (res?.payload?.status === responseTypes.not_found) navigate(`/`);
  };

  useEffect(() => {
    if (isShareable && innCode) {
      dispatch(setIsShareable(isShareable));
      const otherInnCode = selectedPlanDetail?.meta?.planAvailableInncodes?.split(",");
      const hasOtherInncode = otherInnCode?.length > 0;
      if (selectedPlanDetail?.id) {
        setmultipleInncodeFeedback({
          innCode: multipleInncodeFeedback?.innCode,
          otherInnCodes: selectedPlanDetail?.meta?.planAvailableInncodes?.split(",")
        });
        dispatch(setInnCode(multipleInncodeFeedback?.innCode));
        if (hasOtherInncode) setmultipleInncodePlan(true);
        navigate(location.pathname, { state: { backURL: "/library" } });
        return;
      }
      const noAccessCondition = noAccessRedirect();

      if (noAccessCondition) return;

      innCodes?.splice(innCodes?.indexOf(hasOtherInncode ? otherInnCode[0] : innCode), 1);
      const props: any = {
        planId,
        innCode: hasOtherInncode ? otherInnCode[0] : innCode,
        innCodes: innCodes,
        fetchAllImplementedPlans: location?.state?.fetchAllImplementedPlans
      };
      setmultipleInncodeFeedback({
        innCode: hasOtherInncode ? otherInnCode[0] : innCode
      });
      getPlandetails({ ...props });
    }
  }, [dispatch, isShareable, selectedPlanDetail, innCode]);

  const noAccessRedirect = () => {
    const noAccessCondition =
      (Object.keys(selectedPlanDetail).length !== 0 && !selectedPlanDetail?.meta?.planAvailableInncodes) ||
      selectedPlanDetail?.meta?.planAvailableInncodes === null;
    if (noAccessCondition)
      navigate(`/`, {
        state: {
          hasNoAccess: true,
          message: messages.planNotFound
        }
      });
    return noAccessCondition;
  };

  useEffect(() => {
    dispatch(clearAllCardSelection());
    if (selectedPlanDetail?.sections?.length) {
      dispatch(setOpenSections({ [secId ?? selectedPlanDetail?.sections[0]?.id]: true }));
    }
  }, [dispatch, selectedPlanDetail]);

  return (
    <>
      <Feedback
        form=""
        actionStatus={{ shouldShow: multipleInncodePlan, variant: "warning" }}
        message={"You are viewing Plan details for " + multipleInncodeFeedback?.innCode + ". "}
      />

      <Grid
        sx={{
          backgroundColor: tokens.Background.General.Primary,
          padding: isMobileScreen ? "16px" : "40px 24px 40px 32px",
          borderRadius: "12px"
        }}
      >
        {selectedPlanDetail?.planType ||
        location?.state?.redirectFromSuggested ||
        selectedPlanDetail?.isSuggestedPlan ? (
          <Box marginBottom={"8px"}>
            <PlanType
              isSuggestedSection={location?.state?.isSuggestedPannel}
              isSuggested={selectedPlanDetail?.isSuggestedPlan}
              planType={selectedPlanDetail?.planType}
              brandDeadlineDate={selectedPlanDetail?.brandDeadlines && selectedPlanDetail?.brandDeadlines[0]?.deadline}
              initiativeName={selectedPlanDetail?.initiativeName}
            />
          </Box>
        ) : (
          <></>
        )}

        <PlanDetailsContent
          selectedPlanDetail={selectedPlanDetail}
          plansType="AllPlans"
          isPlanBookmark={selectedPlanDetail?.isBookmarked}
          redirectFromDashboard={location?.state?.redirectFromDashboard ?? false}
          isShareable={isShareablePlan}
        />
      </Grid>
      <Grid marginY={2}>
        <Basictabs
          tabDetails={libraryPlanTabs(selectedPlanDetail, "AllPlans")}
          alignItems="left"
          defaultTab={location?.state?.defaultTab}
          isParentTab={true}
        />
      </Grid>
    </>
  );
}
